import React from 'react';
import { Badge } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faServer } from '@fortawesome/free-solid-svg-icons';
import {
  isDevelopmentEnvironment,
  getCurrentPlanEnvironment,
  getCurrentPlanEnvironmentLabel
} from '../../helpers/planConfig';

const PlanEnvironmentIndicator = () => {
  if (!isDevelopmentEnvironment()) {
    return null;
  }

  const color = getCurrentPlanEnvironment() === 'prod' ? 'warning' : 'info';

  return (
    <Badge color={color} className="d-inline-flex align-items-center">
      <FontAwesomeIcon icon={faServer} className="me-1" />
      {getCurrentPlanEnvironmentLabel()}
    </Badge>
  );
};

export default PlanEnvironmentIndicator;
